import React from 'react';
import times from 'lodash/times';
import { Content, Wrapper } from './NetWorthSidebarStyles';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { AccountGroupLoading } from './components/AccountGroup/AccountGroup.loading';

export const NetWorthSidebarLoading = () => {
  return (
    <Wrapper>
      <Content>
        <Box p="16">
          <Text variant="smallCaps">Accounts</Text>
        </Box>

        {times(5).map(key => (
          <AccountGroupLoading key={key} />
        ))}
      </Content>
    </Wrapper>
  );
};
